import { cn } from '#components/utils.js'

export function Input({ className, type = 'text', ...props }) {
  return (
    <input
      className={cn(
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm outline-none transition-shadow placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-75 aria-invalid:border-destructive aria-invalid:ring-destructive/20 motion-reduce:transition-none',
        className,
      )}
      data-slot='input'
      type={type}
      {...props}
    />
  )
}
